/*
Author: Gilang Romadhanu Tartila
*/
'use strict';

import { format, formatISO } from 'date-fns';
import axios from 'axios';
// import { id as localedId } from 'date-fns/locale';
import { enUS as localeEn } from 'date-fns/locale';
/* eslint-disable react-native/split-platform-components */
import Geolocation from 'react-native-geolocation-service';
import Marker, { ImageFormat, Position } from 'react-native-image-marker';

import { Dimensions, Alert, Platform, Linking } from 'react-native';
import { translate } from '@global/translate';
import { readAsync } from '@lodev09/react-native-exify';
import Cookies from 'js-cookie';
import latinize from 'latinize';
import AsyncStorage from '@react-native-async-storage/async-storage';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/id';
dayjs.locale('id');
dayjs.extend(utc);
dayjs.extend(timezone);

import {
  downloadAsync,
  documentDirectory,
  uploadAsync,
} from 'expo-file-system';
import * as FileSystem from 'expo-file-system';
import { shareAsync } from 'expo-sharing';
import { launchCamera, launchImageLibrary } from 'react-native-image-picker';
import SyncStorage from '@global/storage';

import { manipulateAsync, SaveFormat } from 'expo-image-manipulator';

import {
  isWeb,
  isNative,
  isWebPlatform,
  isAndroid,
  isIos,
} from '@global/screens';
import {
  ENV,
  FILE_TYPE,
  ALLOWED_ATTACHMENT_MIME_TYPES,
  ALLOWED_ATTACHMENT_EXTENSIONS,
  CONSTANT,
  STATUS,
  FILTER_PERIOD,
  MONTH_NAME,
  QUOTATION_AMOUNT_THRESHOLD,
  COOKIES_DOMAIN,
  COOKIES_EXPIRY,
} from '@/constants';
import Colors from '@global/colors';
import Toast from 'react-native-toast-message';
import {
  headerLeftContainerStyle,
  headerBackTitleStyle,
} from '@assets/styles/headerStyles';

import packageJson from '../../package.json';

import store from '@/store';
import { MsB2b } from '@api/ms-b2b';
import { setSavedFilter as dispatchSavedFilter } from '@/store/filter';
import { filterAdded, paginationAdded } from '@/store/params';

// import { openSqlite, deleteSqlite } from '@/hooks/useSqlLite';

const Config = getEnvironment();

function hasNoAccess(roles = []) {
  const userRole = store?.getState()?.auth?.user?.role?.code;
  if (userRole && roles?.length) {
    return Boolean(!roles.includes(userRole));
  }
  return true;
}

function imageCdn(options) {
  let isProduction = false;
  if (ENV == 'production') {
    isProduction = true;
  }
  if (isWebPlatform) {
    if (window?.location?.hostname?.indexOf('uat') > -1) {
      isProduction = false;
    }
  }
  const host = isProduction
    ? Config.SOCIOLLA_WEB_URL
    : 'https://www.sociolla.com';
  return `${host}/cdn-cgi/image/${options.config},format=auto,dpr=1.45/${options.image}`;
}

function imageSource(image, width = isWeb ? 250 : 150) {
  const finalUrl = image?.uri ? image.uri : image;
  if (
    finalUrl &&
    finalUrl?.indexOf('http') > -1 &&
    finalUrl?.indexOf('cdn-cgi') == -1
  ) {
    return imageCdn({ config: `w=${width}`, image: finalUrl });
  }
  return image;
}

function getEnvironment() {
  // External domain handling
  if (['nina.ptsemesta.id'].includes(window?.location?.hostname)) {
    return require('~config/external.env').default;
  }

  if (isWebPlatform) {
    return require('~config/default.env').default;
  } else {
    if (ENV == 'production') {
      return require('~config/production.env').default;
    } else {
      return require('~config/default.env').default;
    }
  }
}

// Google Maps key per platform (B2B-6051) so each can be restricted/monitored
// separately in Google Cloud Console:
//  - web + local -> GOOGLE_MAP_KEY
//  - iOS app     -> GOOGLE_MAP_KEY_IOS
//  - Android     -> GOOGLE_MAP_KEY_ANDROID
// NOTE: REST web-service calls (geocode/places) go through the backend proxy,
// not these client keys (see B2B-6052).
function getGoogleMapKey() {
  const env = getEnvironment();
  if (Platform.OS === 'ios') {
    return env.GOOGLE_MAP_KEY_IOS;
  }
  if (Platform.OS === 'android') {
    return env.GOOGLE_MAP_KEY_ANDROID;
  }
  return env.GOOGLE_MAP_KEY;
}

function getMapWebViewBaseUrl() {
  const isVietnam = isVn();
  const Config = getEnvironment();
  if (isWeb && typeof window !== 'undefined') {
    return window.location.origin;
  }
  return isVietnam ? Config?.B2B_WEB_VN_URL : Config?.B2B_WEB_URL;
}

// disabled submit button, values is values of form
function isDisableSubmit(values) {
  let result = true;
  if (values && Object.keys(values).length) {
    const keys = Object.keys(values);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (values[key]) {
        result = false;
      }
    }
  }
  return result;
}

// for task handle task code and task code background on task/notification lists
function handleTaskCode(value) {
  let code = 'CODE';
  let color = '#E5E5E5';

  if (value == 'product_display') {
    code = 'PD';
    color = '#ffd6de';
  } else if (value == 'planogram_guideline') {
    code = 'PG';
    color = '#e8d4ff';
  } else if (value == 'npd') {
    code = 'NPD';
    color = '#ffe2d4';
  } else if (value == 'pending_payment') {
    code = 'PP';
    color = '#d4fff8';
  } else if (value == 'visibility_update') {
    code = 'VU';
    color = '#d6daff';
  } else if (
    [
      'customers',
      'customers-clusters',
      'new_customers',
      'edit_customers',
    ].includes(value)
  ) {
    code = 'CUST';
    if (value == 'new_customers') {
      code = 'NEW';
    } else if (value == 'edit_customers') {
      code = 'EDIT';
    }
    color = '#ffd6e9';
  } else if (value == 'orders') {
    code = 'SO';
    color = '#fff7d4';
  } else if (value == 'return-orders') {
    code = 'RO';
    color = '#fff7d4';
  } else if (value == 'price_rules') {
    code = 'PL';
    color = '#deffcc';
  } else if (value == 'loyalty_points') {
    code = 'LP';
    color = '#ffdbeb';
  } else if (value == 'activities') {
    code = 'CAL';
    color = '#c4d9ff';
  } else if (value == 'target_sales_value') {
    code = 'TARG';
    color = '#deffcc';
  } else if (value == 'target-settings-sales-value-salesman') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'target-settings-sales-value-branch-gt') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'target-settings-sales-value-branch-mt') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'target-settings-sales-value-channel') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'target-settings-sales-value-national') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'target-settings-product-focus-salesman-gt') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'target-settings-product-focus-salesman-mt') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'target-settings-doors-national') {
    code = 'TS';
    color = '#deffcc';
  } else if (value == 'skp-internals' || value == 'skp-externals') {
    code = 'SKP';
    color = '#deffcc';
  } else if (value == 'lpb') {
    code = 'GRN';
    color = '#DBE3FA';
  } else if (value == 'budget-pockets') {
    code = 'BP';
    color = '#deffcc';
  } else if (value == 'promotion-rules') {
    code = 'PR';
    color = '#deffcc';
  } else if (value == 'request-product-tester') {
    code = 'RPT';
    color = '#FAEFDC';
  }

  return { code, color };
}

// date formatter
function parseDate(date, pattern = 'd MMMM yyyy', timeZone = false) {
  if (!date) {
    return;
  }
  let newDate = new Date(date);
  if (timeZone) {
    newDate = changeTimeZone(date);
  }
  return format(newDate, pattern, { locale: localeEn });
}

function changeTimeZone(date, timeZone = 'Asia/Jakarta') {
  if (typeof date === 'string') {
    return new Date(
      new Date(date).toLocaleString('en-US', {
        timeZone,
      }),
    );
  }

  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value;

  const year = get('year');
  const month = get('month');
  const day = get('day');
  const hour = get('hour');
  const minute = get('minute');
  const second = get('second');

  if ([year, month, day, hour, minute, second].some((v) => v == null)) {
    return new Date(NaN);
  }

  const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${second}`;
  return new Date(formattedDate);
}

// function convertMonthNumber(month) {
//   return month < 10 ? `0${month}` : `${month}`;
// }

// date formatter with time ago
function timeAgo(value) {
  const minute = 60 * 1000;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = day * 365;
  const el = new Date() - new Date(value);
  if (el < minute) {
    return `${Math.round(el / 1000)}s`;
  } else if (el < hour) {
    return `${Math.round(el / minute)}m`;
  } else if (el < day) {
    return `${Math.round(el / hour)}h`;
  } else if (el < month) {
    return `${Math.round(el / day)}d`;
  } else if (el < year) {
    return `${Math.round(el / month)}mo`;
  } else {
    return `${Math.round(el / year)}y`;
  }
}

// color generator randomly
function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

function getCenterValue(width) {
  const center = Dimensions.get('window').width / 2 - width / 2;
  return center;
}

// for make capitalize for all first letter words
function firstLetter(value) {
  return value
    ? value.replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      })
    : value;
}

function deSlug(value) {
  return value
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

// handling drawer title
function setTitleHeader(value) {
  if (isWeb) {
    const isVietnam = isVn();
    const companyName = isVietnam
      ? 'Social Bella Vietnam Company Limited'
      : 'PT Semesta Distribusi Indonesia';
    const version = packageJson.version;
    return `V${version} | ${value} - ${companyName}`;
  }
  return value;
}

// default header title style; pass maxWidth to override the 50% default width
function getHeaderTitleStyle(maxWidth, moreTitleSpace = false) {
  return {
    color: '#FFFFFF',
    fontFamily: 'figtree-medium',
    fontSize: 14,
    maxWidth:
      maxWidth ?? (isWeb ? '50vw' : Dimensions.get('window').width * 0.5),
    whitespace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...(moreTitleSpace
      ? {
          marginLeft: 0,
          minWidth: 270,
        }
      : {}),
  };
}

// handle default stack option
function setDefaultStackOption(
  insets,
  CardStyleInterpolators,
  moreTitleSpace = false,
) {
  return {
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
    headerStyle: {
      backgroundColor: Colors.blue1,
    },
    headerTitleAlign: 'left',
    headerTitleStyle: getHeaderTitleStyle(undefined, moreTitleSpace),
    headerLeftContainerStyle,
    headerBackTitleStyle,
    animationEnabled: isIos,
  };
}

// get url from base64
function dataURLtoFile(base64, filename) {
  if (base64) {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  return false;
}

// get mime type from a file
function generateMimeType(name) {
  let result = 'text/plain';
  try {
    const cleanName = name.split('?')[0].split('#')[0];
    const ext = (cleanName.split('.').pop() ?? '').toLowerCase();
    if (ext == 'csv') {
      result = 'text/csv';
    } else if (ext == 'doc') {
      result = 'application/msword';
    } else if (ext == 'docx') {
      result =
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (ext == 'pdf') {
      result = 'application/pdf';
    } else if (ext == 'ppt') {
      result = 'application/vnd.ms-powerpoint';
    } else if (ext == 'pptx') {
      result =
        'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    } else if (ext == 'xls') {
      result = 'application/vnd.ms-excel';
    } else if (ext == 'xlsx') {
      result =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (ext == 'png') {
      result = 'image/png';
    } else if (ext == 'jpg' || ext == 'jpeg') {
      result = 'image/jpeg';
    }
  } catch (error) {}
  return result;
}

export const isAllowedAttachmentFormat = (file) => {
  const mimeType = (file?.mimeType || '').toLowerCase();
  const name = (file?.name || '').toLowerCase();
  const hasAllowedExt = ALLOWED_ATTACHMENT_EXTENSIONS.some((ext) =>
    name.endsWith(ext),
  );
  const hasAllowedMime = ALLOWED_ATTACHMENT_MIME_TYPES.includes(mimeType);
  return hasAllowedMime || hasAllowedExt;
};

// get display file name with extension derived from an uploaded file url
function getFileNameFromUrl(url, baseName) {
  if (!url || typeof url !== 'string') {
    return '';
  }
  const cleanUrl = url.split('?')[0].split('#')[0];
  const lastSegment = cleanUrl.split('/').pop() ?? '';
  const ext = lastSegment.includes('.')
    ? (lastSegment.split('.').pop() ?? '').toLowerCase()
    : '';
  return `${baseName}.${ext || 'pdf'}`;
}

// get combination attribute product
function getAttibutes(data) {
  let variant = '';
  if (data) {
    Object.keys(data).forEach((attr, index) => {
      if (index > 0 && index < Object.keys(data).length) {
        variant = `${variant}, `;
      }
      if (attr === 'non_specify') {
        variant = variant + `${data[attr].name}`;
      } else {
        variant =
          variant +
          `${attr.charAt(0).toUpperCase()}${attr.slice(1)}: ${data[attr].name}`;
      }
    });
  }
  return variant;
}

// get product combination lists
function getProductCombination(combinations) {
  const result = {
    types: [],
    size: [],
    shade: [],
    variant: [],
  };
  if (combinations && combinations.length) {
    const combs = combinations;
    // Get Unique Attibutes
    for (let i = 0; i < combs.length; i++) {
      const com = combs[i];
      if (com && com.attributes && Object.keys(com.attributes).length) {
        const attrs = Object.keys(com.attributes);
        for (let j = 0; j < attrs.length; j++) {
          const attr = attrs[j];
          if (result.types.indexOf(attr) == -1 && attr != 'non_specify') {
            result.types.push(attr);
          }
        }
      }
    }
    // Set Attributes
    for (let i = 0; i < combs.length; i++) {
      const com = combs[i];
      if (com && com.attributes && Object.keys(com.attributes).length) {
        const attrs = com.attributes;
        for (let j = 0; j < result.types.length; j++) {
          const key = result.types[j];
          if (
            attrs[key] &&
            attrs[key].id &&
            result[key].findIndex((a) => a.id == attrs[key].id) == -1
          ) {
            result[key].push({
              ...attrs[key],
              type: key,
              combination_id: com._id,
            });
          }
        }
      }
    }
  }

  return result;
}

function splitProductByCombination(products, noSplit = false) {
  const result = [];
  if (products?.length) {
    for (let i = 0; i < products.length; i++) {
      const item = products[i];
      const obj = { ...item };
      if (item?.combinations?.length) {
        for (let j = 0; j < item?.combinations.length; j++) {
          const com = item?.combinations[j];
          obj.combination = com;
          obj.image = com?.images?.length ? com.images[0]?.url : '';
          obj.reference = com?.reference ? com.reference : '';
          obj.variant = com?.attributes ? getAttibutes(com.attributes) : '';
          obj.price = com.price ? com.price : 0;
          if (noSplit) {
            break;
          }
        }
      }
      result.push(obj);
    }
  }
  return result;
}

function generateStatus(key, data, track) {
  if (STATUS[key]?.length) {
    return STATUS[key].find((st) => st[track] === data) || '';
  } else {
    return '';
  }
}

function generateConstant(key, data, track) {
  if (CONSTANT[key]?.length) {
    return CONSTANT[key].find((st) => st[track] === data) || '';
  } else {
    return '';
  }
}

function getStatus(key) {
  if (STATUS[key]) {
    return STATUS[key];
  } else {
    return '';
  }
}

function getConstant(key) {
  if (CONSTANT[key]) {
    return CONSTANT[key];
  } else {
    return null;
  }
}

// upload file to S3
// isExportOnApps = upload csv file from apps
// isNeedMobileSupport = upload file from mobile apps
async function uploadS3({
  file,
  isImage = false,
  isExportOnApps = false,
  isNeedMobileSupport = false,
  isRename = false,
  isReplaceFile = false,
  // isCache = false,
}) {
  let url = '';
  let newFile = '';
  let fileType = '';
  let fileName = Math.floor(100000000000 * Math.random()) + '-' + Date.now();
  if (isRename) {
    fileName = file?.name || file?.filename;
  }

  if (file && (file.name || file.filename)) {
    fileType = generateMimeType(file?.filename ? file.filename : file.name);
  }

  if (isExportOnApps) {
    newFile = file;
    fileType = 'text/csv';
    fileName = `${fileName}.csv`;
  } else if (isImage) {
    newFile = file.uri;
    fileName = file.filename;
    // B2B-5776: keep the mime type derived from the filename when file.type is
    // empty — overwriting it with undefined makes us request a pre-signed url
    // with no contentType, which S3 then rejects with SignatureDoesNotMatch
    if (file.type && !['success', 'cancel'].includes(file.type)) {
      fileType = file.type;
    }
  } else if (isNeedMobileSupport) {
    newFile = file.uri;
  }

  if (!fileType && file?.mimeType) {
    fileType = file.mimeType;
  }

  // B2B-5776: an image upload must never reach the pre-sign endpoint without a
  // real image mime type. generateMimeType falls back to text/plain for unknown
  // extensions, which the endpoint rejects.
  if (isImage && (!fileType || !fileType.startsWith('image/'))) {
    fileType = 'image/jpeg';
  }

  // set file and file type to upload from web or mobile web
  if (!isNative) {
    if (isImage) {
      const tempFile = dataURLtoFile(newFile, fileName);
      if (tempFile) {
        newFile = tempFile;
        fileType = tempFile.type;
      }
    } else {
      newFile = file.file;
      fileType = file.type;
      if (file?.file?.type) {
        fileType = file.file.type;
      }
    }
  }

  if (!isExportOnApps && fileType && FILE_TYPE[fileType]) {
    if (isAndroid) {
      if (!fileName.includes(`.${FILE_TYPE[fileType]}`)) {
        fileName = `${fileName}.${FILE_TYPE[fileType]}`;
      }
    } else {
      fileName = `${fileName}.${FILE_TYPE[fileType]}`;
    }
  }

  if (isNative) {
    try {
      const extension = fileName.split('.').pop() ?? '';
      if (!extension) {
        Alert.alert(
          translate('Error'),
          translate('Nama file tidak memiliki ekstensi (.jpg/.pdf/.csv)'),
        );
        return false;
      }
    } catch (error) {
      Alert.alert(
        translate('Error'),
        translate('Nama file tidak memiliki ekstensi (.jpg/.pdf/.csv)'),
      );
      return false;
    }
  }

  try {
    if (isAndroid && !isImage && newFile.indexOf('content://') > -1) {
      const RNFS = require('react-native-fs');
      const destPath = `${RNFS.TemporaryDirectoryPath}/${new Date().getTime()}`;
      await RNFS.copyFile(newFile, destPath);
      const { path } = await RNFS.stat(destPath);
      newFile = `file://${path}`;
    }
  } catch (error) {
    return false;
  }

  try {
    if (newFile) {
      const response = await axios.get(
        `${Config.MS_SOCO_PUBLIC_API_URL}/pre-signed-url`,
        {
          params: { fileName: fileName, contentType: fileType, isReplaceFile },
        },
      );
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.url
      ) {
        url = response.data.data.url;
      }

      if (url) {
        // if (isCache) {
        //   return {
        //     url,
        //     payload: {
        //       url: response.data.data.signedUrl,
        //       uri: newFile,
        //       options: {
        //         httpMethod: 'PUT',
        //         mimeType: fileType,
        //         headers: {
        //           'Content-Type': fileType,
        //         },
        //       },
        //     },
        //   };
        // }
        try {
          const signUrl = response.data.data.signedUrl;
          if (!isNative || isExportOnApps) {
            // if uploading from web/mobile web/android or uploading csv from apps
            const newAxios = axios;
            delete newAxios.defaults.withCredentials;
            const putResponse = await newAxios.put(signUrl, newFile, {
              headers: { 'Content-Type': fileType },
            });
            axios.defaults.withCredentials = true;
            const putStatus = putResponse?.status;
            if (!(putStatus >= 200 && putStatus < 300)) {
              console.log('s3-upload-failed', putStatus, putResponse?.data);
              return false;
            }
          } else {
            // if uploading file from apps
            const uploadResult = await uploadAsync(signUrl, newFile, {
              httpMethod: 'PUT',
              mimeType: fileType,
              headers: {
                'Content-Type': fileType,
              },
            });
            // B2B-5776: uploadAsync resolves instead of throwing on a non-2xx
            // response. Without this check a rejected upload still returns the
            // cdn url and is stored as if the file existed.
            const uploadStatus = uploadResult?.status;
            const isUploaded = uploadStatus >= 200 && uploadStatus < 300;
            if (!isUploaded) {
              console.log('s3-upload-failed', uploadStatus, uploadResult?.body);
              return false;
            }
          }

          return url;
        } catch (e) {
          console.log('signurl-error', e);
          return false;
        }
      }
    }
  } catch (e) {
    console.log('upload-error', e);
    return false;
  }

  return false;
}

// async function uploadBackground(filename, { url, uri, options }) {
//   try {
//     const resp = await uploadAsync(url, uri, {
//       ...options,
//       sessionType: FileSystem.FileSystemSessionType.BACKGROUND,
//     });
//     if (resp?.status == 200) {
//       const db = await openSqlite();
//       await deleteSqlite('upload', db, { filename });
//     }
//   } catch (e) {
//     console.warn('ERROR UPLOADING :: ', e);
//   }
// }

function getImageRatio(a, b) {
  for (let result = b; result > 1; result--) {
    if (a % result == 0 && b % result == 0) {
      a = a / result;
      b = b / result;
    }
  }
  return { width: a, height: b };
}

// async function getCompressionSize(file) {
//   if (isWebPlatform) {
//     return 1;
//   }

//   try {
//     const RNFS = require('react-native-fs');
//     const { size: fileSize } = await RNFS.stat(file.uri);
//     const realSize = fileSize / Math.pow(1024, 2);
//     if (Math.round(realSize) === 0) {
//       return 1;
//     }
//     if (Math.round(realSize) === 1) {
//       return 0.9;
//     }
//     if (Math.round(realSize) === 2) {
//       return 0.8;
//     }
//     if (Math.round(realSize) === 3) {
//       return 0.7;
//     }
//     if (Math.round(realSize) === 4) {
//       return 0.6;
//     }
//     if (Math.round(realSize) >= 5) {
//       return 0.5;
//     }
//     if (Math.round(realSize) >= 10) {
//       return 0.4;
//     }
//     if (Math.round(realSize) >= 15) {
//       return 0.3;
//     }
//     if (Math.round(realSize) >= 20) {
//       return 0.2;
//     }
//     if (Math.round(realSize) >= 25) {
//       return 0.1;
//     }
//   } catch (error) {
//     console.log('compression-size-error', error);
//     return 1;
//   }
// }

const MAX_IMAGE_SIZE = 1 * 1024 * 1024;

// B2B-6052: cache reverse-geocode results per ~11m location grid for a short TTL
// so the same spot isn't looked up repeatedly (e.g. burst of watermark photos).
const reverseGeocodeCache = new Map();
const REVERSE_GEOCODE_TTL = 5 * 60 * 1000; // 5 minutes

const requestLocationPermission = async () => {
  if (Platform.OS === 'android') {
    const RN = await import('react-native');
    const granted = await RN.PermissionsAndroid.request(
      RN.PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
      {
        title: 'Location Permission',
        message: 'App needs location access to show your position',
        buttonNeutral: 'Ask Later',
        buttonNegative: 'Deny',
        buttonPositive: 'Allow',
      },
    );
    return granted === RN.PermissionsAndroid.RESULTS.GRANTED;
  }
  return true;
};

const getCurrentLocation = async () => {
  try {
    const hasPermission = await requestLocationPermission();
    if (!hasPermission) {
      console.log('Location permission not granted');
      return null;
    }

    return await new Promise((resolve) => {
      Geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ latitude, longitude });
        },
        (error) => {
          console.log('getCurrentLocation error:', error);
          resolve(null);
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 10000,
          forceRequestLocation: true,
          showLocationDialog: true,
        },
      );
    });
  } catch (error) {
    console.log('getCurrentLocation unexpected error:', error);
    return null;
  }
};

const reverseGeocodeWithGoogle = async (latitude, longitude) => {
  if (!latitude || !longitude || isNaN(latitude) || isNaN(longitude)) {
    console.log('Invalid coordinates for reverse geocoding');
    return '';
  }

  const cacheKey = `${latitude.toFixed(4)},${longitude.toFixed(4)}`;
  const cached = reverseGeocodeCache.get(cacheKey);
  if (cached && Date.now() - cached.at < REVERSE_GEOCODE_TTL) {
    return cached.address;
  }

  try {
    // B2B-6051/6052: go through the ms-accounts backend proxy so the Google key
    // is never shipped in the client. Dynamic import avoids a circular dep
    // (ms-account.js already imports from this module at load time).
    const { googleMapsGeocode } = await import('@api/ms-account');
    const response = await googleMapsGeocode({
      params: { filter: { latlng: `${latitude},${longitude}` } },
    });

    const results = response?.data?.data?.results;
    if (results?.length) {
      const address = results[0].formatted_address || '';
      reverseGeocodeCache.set(cacheKey, { address, at: Date.now() });
      return address;
    }
    console.log('Reverse geocode returned no results');
    return '';
  } catch (error) {
    console.log('reverseGeocodeWithGoogle error:', error);
    return '';
  }
};

const wrapTextByLength = (text, maxLength = 80) => {
  const words = text.split(' ');
  const lines = [];
  let currentLine = '';

  for (const word of words) {
    if ((currentLine + word).length <= maxLength) {
      currentLine += word + ' ';
    } else {
      lines.push(currentLine.trim());
      currentLine = word + ' ';
    }
  }

  if (currentLine.trim()) {
    lines.push(currentLine.trim());
  }

  return lines.join('\n');
};

export async function manipulateImage({ image, isWatermark = true }) {
  try {
    if (isAndroid) {
      const FIXED_WIDTH_PORTRAIT = 1080;
      const FIXED_HEIGHT_PORTRAIT = 1440;
      const FIXED_WIDTH_LANDSCAPE = 1920;
      const FIXED_HEIGHT_LANDSCAPE = 1080;

      const isPortrait = image.height >= image.width;
      const targetWidth = isPortrait
        ? FIXED_WIDTH_PORTRAIT
        : FIXED_WIDTH_LANDSCAPE;
      const targetHeight = isPortrait
        ? FIXED_HEIGHT_PORTRAIT
        : FIXED_HEIGHT_LANDSCAPE;

      const normalized = await manipulateAsync(
        image.uri,
        [
          {
            resize: {
              width: targetWidth,
              height: targetHeight,
            },
          },
        ],
        {
          compress: 1,
          format: SaveFormat.JPEG,
        },
      );

      let timestamp = '';
      let coordinatesStr = '';
      let simplifiedLocation = '';

      try {
        timestamp = dayjs().locale('id').format('DD-MMMM-YYYY hh:mm:ss A');
      } catch (e) {
        console.log('timestamp error:', e);
      }

      try {
        // B2B-6052: only fetch GPS + reverse-geocode when a watermark is actually drawn.
        const location =
          isWatermark && isNative ? await getCurrentLocation() : {};
        if (location && location.latitude && location.longitude) {
          coordinatesStr = `${location.latitude.toFixed(
            6,
          )}, ${location.longitude.toFixed(6)}`;
          const locationStr = await reverseGeocodeWithGoogle(
            location.latitude,
            location.longitude,
          );
          if (locationStr) {
            simplifiedLocation = wrapTextByLength(locationStr, 50);
          }
        }
      } catch (e) {
        console.log('location fetch error:', e);
      }

      const isWatermarkValid =
        timestamp && coordinatesStr && simplifiedLocation;
      let resultUri = normalized.uri;

      if (isWatermarkValid && isWatermark) {
        const { width, height } = normalized;
        const text = `${timestamp}\n${coordinatesStr}\n${simplifiedLocation}`;
        const fontSize = Math.max(Math.round(width / 40), 18);

        const offsetX = Math.round(width * 0.03);
        const offsetY = Math.round(height * 0.03);

        const markedUri = await Marker.markText({
          backgroundImage: {
            src: normalized.uri,
          },
          watermarkTexts: [
            {
              text,
              position: {
                position: Position.bottomLeft,
                offsetX,
                offsetY,
              },
              style: {
                color: '#ffffff',
                fontSize,
                shadowStyle: {
                  dx: 2,
                  dy: 2,
                  radius: 5,
                  color: '#000000',
                },
                strokeStyle: '#000000',
                strokeWidth: 2,
              },
            },
          ],
          quality: 100,
          saveFormat: ImageFormat.jpeg,
        });

        resultUri = markedUri;
      }

      let compressLevel = 1;
      let result = await manipulateAsync(resultUri, [], {
        compress: compressLevel,
        format: SaveFormat.JPEG,
      });

      let fileInfo = await FileSystem.getInfoAsync(result.uri);

      while (fileInfo.size > MAX_IMAGE_SIZE && compressLevel > 0.85) {
        compressLevel -= 0.05;
        result = await manipulateAsync(resultUri, [], {
          compress: compressLevel,
          format: SaveFormat.JPEG,
        });
        fileInfo = await FileSystem.getInfoAsync(result.uri);
      }

      const originalRatio = image.width / image.height;
      const PADDING_RATIO = 0.05;

      let finalWidth = result.width;
      let finalHeight = result.height;

      if (isPortrait) {
        finalWidth = 1080;
        finalHeight = Math.round((1080 / originalRatio) * (1 + PADDING_RATIO));
      } else {
        finalHeight = 1080;
        finalWidth = Math.round(1080 * originalRatio * (1 + PADDING_RATIO));
      }

      const finalImage = await manipulateAsync(
        result.uri,
        [
          {
            resize: {
              width: finalWidth,
              height: finalHeight,
            },
          },
        ],
        {
          compress: 1,
          format: SaveFormat.JPEG,
        },
      );

      return {
        ...image,
        uri: finalImage.uri,
        width: finalImage.width,
        height: finalImage.height,
      };
    } else {
      const normalized = await manipulateAsync(image.uri, [], {
        compress: 1,
        format: SaveFormat.JPEG,
      });

      let timestamp = '';
      let coordinatesStr = '';
      let simplifiedLocation = '';

      try {
        timestamp = dayjs().locale('id').format('DD-MMMM-YYYY hh:mm:ss A');
      } catch (e) {
        console.log('timestamp error:', e);
        timestamp = '';
      }

      try {
        // B2B-6052: only fetch GPS + reverse-geocode when a watermark is actually drawn.
        const location =
          isWatermark && isNative ? await getCurrentLocation() : {};
        if (location && location.latitude && location.longitude) {
          coordinatesStr = `${location.latitude.toFixed(
            6,
          )}, ${location.longitude.toFixed(6)}`;

          const locationStr = await reverseGeocodeWithGoogle(
            location.latitude,
            location.longitude,
          );
          if (locationStr) {
            simplifiedLocation = wrapTextByLength(locationStr || '', 80);
          }
        }
      } catch (e) {
        console.log('location fetch error:', e);
      }

      const isWatermarkValid =
        timestamp && coordinatesStr && simplifiedLocation;
      let resultUri = normalized.uri;

      if (isWatermarkValid) {
        const text = `${timestamp}\n${coordinatesStr}\n${simplifiedLocation}`;
        const fontSize = Math.max(image.width, image.height) / 40;

        const markedUri = await Marker.markText({
          backgroundImage: {
            src: normalized.uri,
          },
          watermarkTexts: [
            {
              text,
              position: {
                position: Position.bottomLeft,
                offsetX: 10,
                offsetY: 20,
              },
              style: {
                color: '#ffffff',
                fontSize: fontSize,
                shadowStyle: {
                  dx: 2,
                  dy: 2,
                  radius: 5,
                  color: '#000000',
                },
                strokeStyle: '#000000',
                strokeWidth: 2,
              },
            },
          ],
          quality: 100,
          saveFormat: ImageFormat.jpeg,
        });

        resultUri = markedUri;
      }

      let compressLevel = 1;
      let result = await manipulateAsync(resultUri, [], {
        compress: compressLevel,
        format: SaveFormat.JPEG,
      });

      let fileInfo = await FileSystem.getInfoAsync(result.uri);

      while (fileInfo.size > MAX_IMAGE_SIZE && compressLevel > 0.85) {
        compressLevel -= 0.05;

        result = await manipulateAsync(resultUri, [], {
          compress: compressLevel,
          format: SaveFormat.JPEG,
        });

        fileInfo = await FileSystem.getInfoAsync(result.uri);
      }

      return {
        ...image,
        uri: result.uri,
        width: result.width,
        height: result.height,
      };
    }
  } catch (error) {
    return image;
  }
}

function resultImage(image) {
  try {
    const fileExtension = image?.uri.split('.').pop() ?? '';
    if (
      fileExtension &&
      /^.*(jpg|jpeg|png).*$/g.test(fileExtension.toLowerCase())
    ) {
      let filename =
        Math.floor(100000000000 * Math.random()) + '-' + Date.now();
      if (fileExtension.toLowerCase().includes('png')) {
        filename = filename + '.png';
        image.type = 'image/png';
      } else {
        filename = filename + '.jpg';
        image.type = 'image/jpeg';
      }
      return {
        uri: image.uri,
        filename,
        type: image.type,
      };
    }
    return false;
  } catch (error) {
    console.log('result-image', error);
    return false;
  }
}

async function chooseMultipleImagePicker(resizeWidth = 1000) {
  try {
    const response = await launchImageLibrary({
      mediaType: 'photo',
      quality: isWeb ? 1 : 0.5,
      selectionLimit: 0,
    });
    if (response.didCancel) {
      console.log('User canceled the camera action');
    } else if (response.errorCode) {
      console.log('ImagePicker Error: ', response.errorMessage);
    } else {
      const images = [];
      for (const res of response.assets) {
        const imageResponse = {
          uri: res.uri,
          width: res.width,
          height: res.height,
        };

        // B2B-3763, B2B-3888
        if (isAndroid) {
          try {
            const tags = await readAsync(imageResponse.uri);
            if (tags?.Orientation == 6 || tags?.Orientation == 8) {
              const tempWidth = imageResponse.width;
              const tempHeight = imageResponse.height;
              imageResponse.width = tempHeight;
              imageResponse.height = tempWidth;
            }
          } catch (error) {
            console.log('error when handle rotation', error);
          }
        }

        const finalUri = await manipulateImage({
          image: imageResponse,
          size: resizeWidth,
        });
        images.push(resultImage(finalUri));
      }
      return images;
    }
  } catch (error) {
    return false;
  }
}

// handle choose image
async function chooseImagePicker(resizeWidth = 1000, isWatermark = true) {
  try {
    const options = {
      mediaType: 'photo',
    };

    const result = await new Promise((resolve) =>
      launchImageLibrary(options, (response) => resolve(response)),
    );

    if (result && result.assets && result.assets.length > 0) {
      const picked = result.assets[0];

      // B2B-3763, B2B-3888
      if (isAndroid) {
        try {
          const tags = await readAsync(picked.uri);
          if (tags?.Orientation == 6 || tags?.Orientation == 8) {
            const tempWidth = picked.width;
            const tempHeight = picked.height;
            picked.width = tempHeight;
            picked.height = tempWidth;
          }
        } catch (error) {
          console.log('error when handle rotation', error);
        }
      }

      const finalUri = await manipulateImage({
        image: picked,
        size: resizeWidth,
        isWatermark,
      });

      return resultImage(finalUri);
    }
    return false;
  } catch (error) {
    console.log('chooseImagePicker error', error);
    return false;
  }
}

async function launchCameraAsync(options) {
  return new Promise((resolve, reject) => {
    launchCamera(options, (res) => {
      if (res.didCancel) {
        resolve({ didCancel: true });
      } else if (res.errorCode) {
        reject(new Error(`ImagePicker Error: ${res.errorMessage}`));
      } else {
        resolve(res);
      }
    });
  });
}

const requestCameraPermission = async () => {
  try {
    if (Platform.OS === 'android') {
      const RN = await import('react-native');
      const granted = await RN.PermissionsAndroid.request(
        RN.PermissionsAndroid.PERMISSIONS.CAMERA,
        {
          title: 'App Camera Permission',
          message: 'App needs access to your camera',
          buttonNeutral: 'Ask Me Later',
          buttonNegative: 'Cancel',
          buttonPositive: 'OK',
        },
      );
      if (granted === RN.PermissionsAndroid.RESULTS.GRANTED) {
        return true;
      } else {
        console.log('Camera permission denied');
        return false;
      }
    } else if (isIos) {
      return true;
    }
  } catch (err) {
    console.warn(err);
    return false;
  }
};

// [B2B-5968] Device-local preference for auto-saving taken photos to the gallery. Defaults to
// on (B2B-5928 behaviour) until the user turns it off from the Profile screen.
const AUTO_SAVE_PHOTO_KEY = 'B2B-AUTO-SAVE-PHOTO';

async function getAutoSavePhoto() {
  try {
    return (await AsyncStorage.getItem(AUTO_SAVE_PHOTO_KEY)) !== 'false';
  } catch (error) {
    return true;
  }
}

// Turning it on asks for gallery permission; returns false (and stores nothing) when denied.
async function setAutoSavePhoto(enabled) {
  try {
    if (enabled) {
      // eslint-disable-next-line global-require
      const MediaLibrary = require('expo-media-library');
      const { granted } = await MediaLibrary.requestPermissionsAsync(true);
      if (!granted) {
        return false;
      }
    }
    await AsyncStorage.setItem(AUTO_SAVE_PHOTO_KEY, String(!!enabled));
    return true;
  } catch (error) {
    console.log('set auto save photo error', error);
    return false;
  }
}

// [B2B-5968] Read-only gallery permission check (never prompts), so the Profile toggle can
// reflect a permission the user revoked in device settings.
async function hasGalleryPermission() {
  if (!isNative) {
    return false;
  }
  try {
    // eslint-disable-next-line global-require
    const MediaLibrary = require('expo-media-library');
    const { granted } = await MediaLibrary.getPermissionsAsync(true);
    return granted;
  } catch (error) {
    return false;
  }
}

// [B2B-5928] Saves the processed photo (with the timestamp/location watermark) to the device
// gallery. Best-effort: a denied permission or failed save never blocks the photo upload.
// Required lazily inside the try: expo-media-library throws at import time when its native
// module isn't in the binary (a build without pod install, or an OTA update on an older build),
// so a top-level import would crash the app on launch. Use require, not import() — Metro splits
// import() into a separate dev bundle, and loading it reloads the JS runtime mid-capture.
async function savePhotoToGallery(uri) {
  if (!isNative || !uri) {
    return;
  }
  try {
    if (!(await getAutoSavePhoto())) {
      return;
    }
    // eslint-disable-next-line global-require
    const MediaLibrary = require('expo-media-library');
    const { granted } = await MediaLibrary.requestPermissionsAsync(true);
    if (granted) {
      await MediaLibrary.saveToLibraryAsync(uri);
    }
  } catch (error) {
    console.log('save photo to gallery error', error);
  }
}

// handle opening camera
async function takePicture(resizeWidth = 400) {
  try {
    const options = {
      // [B2B-5928] Don't let the picker save the raw camera shot — the gallery copy is saved
      // after manipulateImage below, so it includes the timestamp watermark (B2B-5822).
      saveToPhotos: false,
      mediaType: 'photo',
      includeBase64: false,
      quality: 1,
      includeExtra: true,
      ...(isAndroid
        ? {
            skipBackup: true,
            path: 'images',
            cameraRoll: true,
            waitUntilSaved: true,
          }
        : {}),
    };

    const isPermit = await requestCameraPermission();

    if (isPermit) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          try {
            const res = await launchCameraAsync(options);

            if (res?.assets?.[0]) {
              const captured = res.assets[0];

              // B2B-3763, B2B-3888
              if (isAndroid) {
                try {
                  const tags = await readAsync(captured.uri);
                  if (tags?.Orientation == 6 || tags?.Orientation == 8) {
                    const tempWidth = captured.width;
                    const tempHeight = captured.height;
                    captured.width = tempHeight;
                    captured.height = tempWidth;
                  }
                } catch (error) {
                  console.log('error when handle rotation', error);
                }
              }

              const finalUri = await manipulateImage({
                image: captured,
                size: resizeWidth,
              });
              savePhotoToGallery(finalUri?.uri);

              const result = resultImage(finalUri);
              resolve(result);
            } else {
              console.log('No image captured');
              resolve({});
            }
          } catch (error) {
            console.log('Error during camera launch or processing', error);
            resolve({});
          }
        }, 500);
      });
    } else {
      console.log('Permission denied');
      return {};
    }
  } catch (error) {
    console.log('takePicture error', error);
    return {};
  }
}

async function downloadFromUrlAndroid(url, filename, mimeType) {
  try {
    const permissions =
      await FileSystem.StorageAccessFramework.requestDirectoryPermissionsAsync();
    if (permissions.granted) {
      const base64 = await FileSystem.readAsStringAsync(url, {
        encoding: FileSystem.EncodingType.Base64,
      });
      const uri = await FileSystem.StorageAccessFramework.createFileAsync(
        permissions.directoryUri,
        filename,
        mimeType,
      );
      await FileSystem.writeAsStringAsync(uri, base64, {
        encoding: FileSystem.EncodingType.Base64,
      });
      if (uri) {
        Alert.alert(
          translate('Information'),
          translate('File downloaded successfully'),
        );
      }
      return uri ? true : false;
    }
  } catch (err) {
    Alert.alert(translate('Error'), translate('Failed to download file'));
    return false;
  }
}

async function downloadFromCsvTemplateAndroid(csvTemplate, fileName) {
  const permissions =
    await FileSystem.StorageAccessFramework.requestDirectoryPermissionsAsync();
  if (permissions.granted) {
    const uri = await FileSystem.StorageAccessFramework.createFileAsync(
      permissions.directoryUri,
      fileName,
      'text/csv',
    );
    await FileSystem.writeAsStringAsync(uri, csvTemplate);
  } else {
    throw new Error('Android file permission not granted');
  }
}

async function downloadCsvTemplate(csvTemplate, fileName) {
  const formattedFileName = `${new Date().getTime()}_${fileName}`;
  try {
    if (isWebPlatform) {
      const blob = new Blob([csvTemplate], {
        type: 'text/csv;charset=utf-8;',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', formattedFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } else {
      if (isAndroid) {
        await downloadFromCsvTemplateAndroid(csvTemplate, formattedFileName);
      } else {
        const fileUri = `${FileSystem.cacheDirectory}${formattedFileName}`;
        await FileSystem.writeAsStringAsync(fileUri, csvTemplate);
        await shareAsync(fileUri, { mimeType: 'text/csv' });
      }
    }
  } catch (error) {
    console.error('error: ', error);
    Alert.alert(translate('Error'), translate('Failed to download file'));
  }
}

// handling download file
async function downloadFile(
  url,
  file_title = 'download',
  ext = 'csv',
  isJump = false,
  isHardOpen = false,
) {
  if (url) {
    const validExts = [
      'csv',
      'pdf',
      'jpg',
      'jpeg',
      'png',
      'gif',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pptx',
    ];
    ext = validExts.includes(ext) ? `.${ext}` : ``;
    const fileType = generateMimeType(url);
    if (!ext) {
      if (FILE_TYPE[fileType]) {
        ext = `.${FILE_TYPE[fileType]}`;
      }
    }
    const filename =
      `${file_title}${new Date().getTime()}${ext}` || `download${ext}`;
    if (!isNative) {
      if (isHardOpen) {
        window.open(url, '_blank');
        return;
      }
      const link = document.createElement('a');
      if (link.download !== undefined) {
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        if (isJump) {
          link.setAttribute('target', '_blank');
        }
        if (ext !== '.csv' || isHardOpen) {
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      return true;
    } else {
      try {
        const { uri } = await downloadAsync(url, documentDirectory + filename);
        if (isAndroid) {
          const result = await downloadFromUrlAndroid(uri, filename, fileType);
          return result;
        } else {
          const UTI = 'public.item';
          await shareAsync(uri, { UTI });
          return uri ? true : false;
        }
      } catch (e) {
        return false;
      }
    }
  }
  return false;
}

const downloadDirectFile = (url, file_title = 'download', ext = 'csv') => {
  try {
    if (!url) {
      return;
    }

    const validExtsD = [
      'csv',
      'pdf',
      'jpg',
      'jpeg',
      'png',
      'gif',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pptx',
    ];
    ext = validExtsD.includes(ext) ? `.${ext}` : '';
    if (!ext) {
      const mimeType = generateMimeType(url);
      if (FILE_TYPE[mimeType]) {
        ext = `.${FILE_TYPE[mimeType]}`;
      }
    }
    const filename = `${file_title}${new Date().getTime()}${ext}`;

    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => console.error('Download error:', err));
  } catch (e) {
    console.error('Error in downloadDirectFile:', e);
  }
};

// handling csv export
async function exportCSVFile(headers, data, file_title) {
  if (headers) {
    data.unshift(headers);
  }
  const json_obj = JSON.stringify(data);
  const json_converted =
    typeof json_obj != 'object' ? JSON.parse(json_obj) : json_obj;
  let csv = '';
  for (let i = 0; i < json_converted.length; i++) {
    let line = '';
    for (const j in json_converted[i]) {
      if (line != '') {
        line += ',';
      }
      line += json_converted[i][j];
    }
    csv += line + '\r\n';
  }
  const filename = `${file_title}${new Date().getTime()}.csv` || 'export.csv';
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

  if (!isNative) {
    // if downloading csv from web or mobile web
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const blobUrl = URL.createObjectURL(blob);
        link.setAttribute('href', blobUrl);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    return true;
  } else {
    // if downloading csv from apps
    const uploadUrl = await uploadS3({ file: csv, isExportOnApps: true });
    if (uploadUrl) {
      try {
        if (isAndroid) {
          const result = await downloadFromUrlAndroid(uploadUrl, filename);
          return result;
        } else {
          const { uri } = await downloadAsync(
            uploadUrl,
            documentDirectory + filename,
          );
          const UTI = 'public.item';
          await shareAsync(uri, { UTI });
          return uri ? true : false;
        }
      } catch (e) {
        return false;
      }
    }
    return false;
  }
}

// convert address object to string
function convertFullAddress(value, withName = false) {
  if (value) {
    const result = [];

    if (withName && value?.name) {
      result.push(value.name);
    }
    if (value?.street) {
      result.push(value.street);
    }
    if (value?.district?.name) {
      result.push(value.district.name);
    }
    if (value?.city?.name) {
      result.push(value.city.name);
    }
    if (value?.province?.name) {
      result.push(value.province.name);
    }
    if (value?.country?.name) {
      result.push(value.country.name);
    }
    if (value?.postal_code) {
      result.push(value.postal_code);
    }

    if (result?.length) {
      return result.join(', ');
    }
  } else {
    return '-';
  }
}

// get latitute and longitude from delivery or store address customer
function getLongLat(value, index = 0, addressType = 'delivery') {
  const addressKey =
    addressType === 'store' ? 'store_address' : 'delivery_address';

  if (value[addressKey]?.length) {
    const address = value[addressKey][index];

    if (address?.lat_long?.latitude && address?.lat_long?.longitude) {
      return address?.lat_long;
    }
  }
  return null;
}

function generateGMapsLink(lng, lat) {
  if (lng && lat) {
    return `https://maps.google.com/maps?q=${lng},${lat}`;
  }
  return '';
}

// convert value to currency format
function currency(value, withSymbol = false, withDecimal = false) {
  const isViet = isVn();
  let symbol = '';
  if (withSymbol) {
    symbol = getCurrency();
  }
  if (!value) {
    if (isViet) {
      return `0 ${symbol}`;
    } else {
      return `${symbol} 0`;
    }
  }
  if (withDecimal) {
    const res = (value || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    if (isViet) {
      return `${res} ${symbol}`;
    } else {
      return `${symbol} ${res}`;
    }
  }
  const res = parseInt(value || 0)
    .toString()
    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  if (isViet) {
    return `${res} ${symbol}`;
  } else {
    return `${symbol} ${res}`;
  }
}

function capitalizeText(value) {
  if (value) {
    try {
      value = value.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
    } catch (error) {}
  }
  return value;
}

// get distance about two latitute and longitude as KM (kilometers)
function calculateLocationDistance(lat_1, long_1, lat_2, long_2) {
  const toRadians = (Value) => (Value * Math.PI) / 180;

  const R = 6371; // km
  const lat_radians = toRadians(lat_2 - lat_1);
  const long_radians = toRadians(long_2 - long_1);
  const lat_1_convert = toRadians(lat_1);
  const lat_2_convert = toRadians(lat_2);

  const a =
    Math.sin(lat_radians / 2) * Math.sin(lat_radians / 2) +
    Math.sin(long_radians / 2) *
      Math.sin(long_radians / 2) *
      Math.cos(lat_1_convert) *
      Math.cos(lat_2_convert);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km

  return d;
}

// allow input number only for input text form
function numberOnly(value) {
  if (value) {
    return value.replace(/\D/gm, '');
  }
  return value;
}

// Strip line breaks (\r, \n) and tabs (\t) from single-line input text so a pasted value
// can't inject hidden newlines/tabs. Runs collapse to a single space. NOT trimmed on purpose:
// this runs on every keystroke, and trimming would stop the user typing a trailing space.
function stripLineBreaks(value) {
  return typeof value === 'string' ? value.replace(/[\r\n\t]+/g, ' ') : value;
}

// allow input number and decimal point for input text form
function numberWithDecimal(value) {
  if (value) {
    // Remove all characters except digits and decimal point
    let cleaned = value.replace(/[^\d.]/gm, '');

    // Ensure only one decimal point is allowed
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }

    return cleaned;
  }
  return value;
}

// get unique item array
function getUniqeItem(array = [], key = 'id', subKey = '') {
  const arr = [];
  for (let i = 0; i < array.length; i++) {
    const item = array[i];
    if (
      arr.findIndex(
        (a) =>
          a[key] == item[key] && (subKey ? a[subKey] == item[subKey] : true),
      ) == -1
    ) {
      arr.push(item);
    }
  }
  return arr;
}

// generating filter for promotion rules
function promotionRulesParameters({
  existing = {},
  product = {},
  customer = {},
  sales_team = {},
}) {
  const filter = {};
  const finalFilter = existing;

  if (product?.id || Array.isArray(product)) {
    let filter_product = '';
    let filter_product_combination = '';
    let filter_brand = '';
    let filter_category = '';
    if (Array.isArray(product) && product?.length) {
      filter_product = { $in: product.map((a) => a.id).filter((a) => a) };
      filter_product_combination = {
        $in: product.map((a) => a?.combination?.id).filter((a) => a),
      };
      filter_brand = {
        $in: product
          .map((a) => {
            return a.brand ? a.brand.id : null;
          })
          .filter((a) => a),
      };
      const cats = product
        .map((a) => {
          return a?.category ? a?.category?.id : null;
        })
        .filter((a) => a);
      if (cats?.length) {
        filter_category = { $in: cats };
      }
    } else {
      filter_product = product.id;
      filter_product_combination = product.combination?.id;
      if (product.brand) {
        filter_brand = product.brand.id;
      }
      if (product?.category) {
        filter_category = product?.category?.id;
      }
    }
    filter.products = [
      {
        'rules.products.id': filter_product,
        ...(filter_product_combination
          ? { 'rules.products.combination_id': filter_product_combination }
          : {}),
      },
      { 'rules.brands.id': filter_brand },
      { 'rules.is_applicable_for_all_products': true },
    ];
    if (filter_category) {
      filter.products.push({ 'rules.categories.id': filter_category });
    }
  }
  if (customer?.id) {
    filter.customers = [
      { 'rules.customers.id': customer.id },
      { 'rules.is_applicable_for_all_customers': true },
    ];
    if (customer?.market_type?.id && customer?.market_type?.business_type?.id) {
      filter.customers.push({
        'rules.market_types.id': customer.market_type.id,
        'rules.market_types.business_types.id':
          customer.market_type.business_type.id,
      });
    }
    if (customer?.cluster?.id) {
      filter.customers.push({
        'rules.clusters.id': customer.cluster.id,
      });
    }
    if (customer?.customer_type?._id) {
      filter.customers.push({
        'rules.customer_types.customer_type_id': customer.customer_type._id,
      });
    }
  }
  if (sales_team?.id) {
    filter.sales_team = [
      { 'rules.sales_team.id': sales_team.id },
      { 'rules.is_applicable_for_all_sales_team': true },
    ];
  }
  if (filter && Object.keys(filter).length) {
    if (Object.keys(filter).length > 1) {
      finalFilter['$and'] = [
        { $or: filter.products },
        ...(filter.customers?.length ? [{ $or: filter.customers }] : []),
        { $or: filter.sales_team },
      ];
    } else {
      finalFilter['$or'] = filter.products?.length
        ? filter.products
        : filter.customers?.length
        ? filter.customers
        : filter.sales_team;
    }
  }

  finalFilter['is_active'] = true;
  finalFilter['current_status'] = 'approved';
  finalFilter['from_date'] = { $lte: new Date().toISOString() };
  finalFilter['to_date'] = { $gte: new Date().toISOString() };

  return finalFilter;
}

// export csv with fetch api
async function exportCsvApi(
  type,
  payload = {},
  additional = { isDownload: true, message: 'Data has been export.' },
) {
  try {
    const exportData = await MsB2b.exportCsv(type, payload);
    if (exportData?.data?.data) {
      if (additional.isDownload) {
        downloadFile(
          exportData.data.data,
          additional.fileTitle || type,
          'csv',
          true,
        );
      }
      Toast.show({ text1: additional.message, type: 'success' });
    } else {
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  } catch (error) {
    Toast.show({
      text1: error?.response?.data?.message || 'A system error occurred',
      type: 'error',
    });
  }
}

function convertUnderscoreString(value) {
  if (value) {
    value = value.replace(/_/g, ' ');
    if (!value.toLowerCase().includes('cbd')) {
      value = capitalizeText(value);
    }
  }
  return value;
}

// SYNC: This function mirrors calculateSalesOrderProduct in
// b2b-ms-orders/app/controllers/order-utils.js (BE persistence calculation).
// Any formula change here MUST also be applied to that file.
function calculateSalesOrderProduct(product) {
  const result = {
    tax: 0,
    price: 0,
    total_price: 0,
  };
  if (product.unit_price) {
    const unit_price = Number(product.unit_price);
    const qty = Number(product.quantity);
    const default_tax = product?.taxes?.percentage
      ? product.taxes.percentage
      : 0;
    // const rules_1 = product.discount_percentage1?.percentage
    //   ? Number(product.discount_percentage1.percentage)
    //   : product?.discount_percentage1?.discount_info?.deduction_percentage
    //   ? Number(product.discount_percentage1.discount_info.deduction_percentage)
    //   : 0;
    // const rules_2 = product.discount_percentage2?.percentage
    //   ? Number(product.discount_percentage2.percentage)
    //   : product?.discount_percentage2?.discount_info?.deduction_percentage
    //   ? Number(product.discount_percentage2.discount_info.deduction_percentage)
    //   : 0;
    const rules_1 = product.discount_percentage1?.prorate_percentage
      ? Number(product.discount_percentage1.prorate_percentage)
      : 0;
    const rules_2 = product.discount_percentage2?.prorate_percentage
      ? Number(product.discount_percentage2.prorate_percentage)
      : 0;
    let product_tax = 0;
    let tax = 0;
    let product_amount = 0;
    let product_amount_real = 0;
    const countDiscount = (price, disc) => {
      return disc ? price * (disc / 100) : 0;
    };
    const calculateDiscount = (price, promo_1, promo_2) => {
      let product_amount = price;

      const discount_1 = countDiscount(product_amount, promo_1);
      product_amount = product_amount - discount_1;
      const discount_2 = countDiscount(product_amount, promo_2);
      product_amount = product_amount - discount_2;

      return product_amount;
    };
    if (product.taxes.type == 'inc') {
      const min_tax = 1 + default_tax / 100;
      tax = unit_price / min_tax;
      product_tax = unit_price - tax;

      product_amount = (unit_price - product_tax) * qty;
      product_amount = calculateDiscount(product_amount, rules_1, rules_2);
      product_amount_real = unit_price * qty;
      product_amount_real = calculateDiscount(
        product_amount_real,
        rules_1,
        rules_2,
      );

      product_tax = calculateDiscount(product_tax, rules_1, rules_2) * qty;
    } else {
      const min_tax = default_tax / 100;
      product_tax = unit_price * qty * min_tax;

      product_amount = unit_price * qty;
      product_amount = calculateDiscount(product_amount, rules_1, rules_2);
      product_amount_real = (unit_price + unit_price * min_tax) * qty;
      product_amount_real = calculateDiscount(
        product_amount_real,
        rules_1,
        rules_2,
      );

      product_tax = calculateDiscount(product_tax, rules_1, rules_2);
    }
    result.tax = Math.round(product_tax);
    result.price = Math.round(product_amount);
    result.total_price = Math.round(product_amount_real);
  }

  return result;
}

const SAVED_FILTER_STORAGE_KEY = 'savedFilter_';

async function _persistFilter(screen, payload) {
  const key = SAVED_FILTER_STORAGE_KEY + screen;
  const value = JSON.stringify(payload);
  if (isWeb) {
    localStorage.setItem(key, value);
  } else {
    await AsyncStorage.setItem(key, value);
  }
}

async function _clearPersistedFilter(screen) {
  const key = SAVED_FILTER_STORAGE_KEY + screen;
  if (isWeb) {
    localStorage.removeItem(key);
  } else {
    await AsyncStorage.removeItem(key);
  }
}

async function _getPersistedFilter(screen) {
  const key = SAVED_FILTER_STORAGE_KEY + screen;
  try {
    const value = isWeb
      ? localStorage.getItem(key)
      : await AsyncStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

function setSavedFilter(
  { filters = {}, paginations = null, reset = false },
  fromState = false,
  screenName,
  childScreen = [],
) {
  const screen = screenName
    ? screenName
    : store?.getState()?.global.route.current;
  const params = store?.getState()?.params;
  let filter = filters;
  let pagination = paginations;
  if (reset) {
    store.dispatch(dispatchSavedFilter({}));
    _clearPersistedFilter(screen);
    return;
  }
  if (!pagination && params?.skip && params?.limit) {
    pagination = {
      skip: params.skip,
      limit: params.limit,
    };
  }
  if (fromState && params) {
    filter = params.filter;
  }
  // When only pagination is being updated (no explicit filter), preserve the existing saved filter
  if (!Object.keys(filter).length && paginations) {
    const existingSaved = store?.getState()?.filter.savedFilter;
    if (
      existingSaved?.screen === screen &&
      existingSaved?.filter &&
      Object.keys(existingSaved.filter).length
    ) {
      filter = existingSaved.filter;
    }
  }
  const payload = { screen, filter, pagination: paginations, childScreen };
  store.dispatch(dispatchSavedFilter(payload));
  if (filter && Object.keys(filter).length) {
    _persistFilter(screen, payload);
  } else {
    _clearPersistedFilter(screen);
  }
}

async function getSavedFilter(current = null) {
  const screen = current ? current : store?.getState()?.global.route.current;
  let filter = store?.getState()?.filter.savedFilter;
  if (!filter || screen !== filter.screen) {
    const persisted = await _getPersistedFilter(screen);
    if (persisted && persisted.screen === screen) {
      store.dispatch(dispatchSavedFilter(persisted));
      filter = persisted;
    }
  }
  if (filter && screen && screen == filter.screen) {
    const res = {
      filter: null,
      limit: null,
      skip: null,
    };
    // Restore filter first — filterAdded resets skip to 0, so pagination must be applied after
    if (filter?.filter && Object.keys(filter.filter).length) {
      await store.dispatch(filterAdded(filter.filter));
      res.filter = filter.filter;
    } else {
      await store.dispatch(dispatchSavedFilter({ ...filter, filter: {} }));
    }
    if (filter.pagination?.limit && filter.pagination?.skip > 0 && isWeb) {
      res.limit = filter.pagination.limit;
      res.skip = filter.pagination.skip;
      await store.dispatch(
        paginationAdded({ limit: res.limit, skip: res.skip }),
      );
    } else {
      await store.dispatch(dispatchSavedFilter({ ...filter, pagination: {} }));
    }
    return res;
  }
  return null;
}

function convertMarketTypeData(data) {
  const result = [];
  const source = isVn() ? 'b2b_vn' : 'b2b';

  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (item?.business_type?.length) {
      for (let j = 0; j < item.business_type.length; j++) {
        const bt = item.business_type[j];
        if ((bt.is_active_for || []).includes(source)) {
          result.push({
            id: item._id,
            code: item.code.toUpperCase(),
            business_type_index: 0,
            business_type_id: bt._id,
            business_type: bt.code,
            business_type_description: bt.description,
            business_type_is_active: bt.is_active,
            customer_payment_terms: bt?.customer?.payment_terms?.name || '',
            customer_limit_amount: bt?.customer?.limit_amount || '',
            customer_cluster: bt?.customer?.cluster?.name || '',
            total_products_premium: Number(
              bt.total_products_premium || 0,
            )?.toString(),
            total_products_non_premium: Number(
              bt.total_products_non_premium || 0,
            )?.toString(),
          });
        }
      }
    } else {
      result.push({
        id: item._id,
        code: item.code.toUpperCase(),
        business_type_index: 0,
        business_type_id: '',
        business_type: '',
        business_type_description: '',
        customer_payment_terms: '',
        customer_limit_amount: '',
        customer_cluster: '',
        total_products_premium: 0,
        total_products_non_premium: 0,
      });
    }
  }

  return result;
}

function csvToArray(str) {
  const detectDelimiter = (input) => {
    const separators = [',', ';', '|', '\t'];
    const idx = separators
      .map((separator) => input.indexOf(separator))
      .reduce((prev, cur) =>
        prev === -1 || (cur !== -1 && cur < prev) ? cur : prev,
      );
    return input[idx] || ',';
  };

  const headerString = str.slice(0, str.indexOf('\n'));
  const delimiter = detectDelimiter(headerString);
  const headers = headerString.split(delimiter);
  const rows = str.slice(str.indexOf('\n') + 1).split('\n');
  const arr = rows.map(function (row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function (object, header, index) {
      header = header.replace(/\s/g, '');
      object[header] = values[index]?.replace(/\r/g, '');
      return object;
    }, {});
    return el;
  });

  return arr;
}

function convertTimeOfDate(date, time, tz = 'Asia/Jakarta') {
  const result = changeTimeZone(date, tz);
  try {
    if (time) {
      const time_split = time.split(':');
      result.setHours(time_split[0], time_split[1], 0);
    }
  } catch (error) {}
  return result;
}

function randomString(length = 5) {
  let result = '';
  const char = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const charLength = char.length;
  for (let i = 0; i < length; i++) {
    result += char.charAt(Math.floor(Math.random() * charLength));
  }
  return result;
}

function convertProductMarketType(item) {
  if (item?.products) {
    item = {
      ...item,
      ...item.products,
    };
  }
  if (item?.products?.id) {
    item.id = item.products.id;
    item.name = item.products.name;
  }
  if (item?.combination?.id) {
    item.combination._id = item.combination.id;
    item.combinations = [item.combination];
    if (item.combination?.image && !item.image) {
      item.image = item.combination.image;
    }
  }
  if (
    item.reference &&
    item.product_combination_id &&
    !item?.combinations?.length
  ) {
    item.combinations = [
      {
        _id: item.product_combination_id,
        reference: item.reference,
        image: item.image,
      },
    ];
  }
  item.product_name = item.name;
  if (item?.combinations?.length) {
    item.combinations = item.combinations.filter((com) =>
      isVn()
        ? com.is_active_in_b2b_vn !== false
        : com.is_active_in_b2b !== false,
    );
    if (!item?.combination) {
      item.combination = item.combinations[0];
    }
  }
  if (!item.name && item?.product?.name) {
    item.name = item.product.name;
  }
  const selectedCombination = item.combination;
  if (
    selectedCombination?.images?.length &&
    item.images?.[0]?.url &&
    !item.image
  ) {
    item.image = item.images[0]?.url || '';
  }
  if (selectedCombination?.reference) {
    item.product_name = `[${selectedCombination.reference}] ${item.name}`;
  }
  if (!item.product_combination_id) {
    item.product_combination_id = selectedCombination._id;
  }
  if (selectedCombination?.price) {
    item.price = selectedCombination.price;
  } else if (item?.products?.combination?.price) {
    item.price = item.products.combination.price;
  } else {
    if (!item.price && item?.products?.price) {
      item.price = item.products.price;
    }
  }
  if (item.price && isNaN(Number(item.price))) {
    item.price = 0;
  }
  if (!item.reference && item?.products?.combination?.reference) {
    item.reference = item.products.combination.reference;
  }
  if (
    !item.variant &&
    item?.product?.combination?.attributes &&
    Object.keys(item.product.combination.attributes).length
  ) {
    item.variant = getAttibutes(item.product.combination.attributes);
  }
  if (!item.image) {
    if (item?.products?.combination?.image) {
      item.image = item.products.combination.image;
    } else if (selectedCombination?.image) {
      item.image = selectedCombination.image;
    }
  }
  if (!item.reference && selectedCombination?.reference) {
    item.reference = selectedCombination.reference;
  }
  if (
    !item.variant &&
    selectedCombination?.attributes &&
    Object.keys(selectedCombination.attributes).length
  ) {
    item.variant = getAttibutes(selectedCombination.attributes);
  }
  if (item?.tags?.length) {
    const tags = item.tags;
    item.is_best_seller = tags.indexOf('bestseller') > -1;
    item.is_new = tags.indexOf('new_arrival') > -1;
    item.is_promo = tags.indexOf('promo') > -1;
  } else {
    item.is_best_seller = false;
    item.is_new = false;
    item.is_promo = false;
  }
  if (selectedCombination?.tags?.length) {
    if (selectedCombination?.tags?.length) {
      const tags = selectedCombination.tags;
      item.is_best_seller = tags.indexOf('bestseller') > -1;
      item.is_new = tags.indexOf('new_arrival') > -1;
      item.is_promo = tags.indexOf('promo') > -1;
    } else {
      item.is_best_seller = false;
      item.is_new = false;
      item.is_promo = false;
    }
  }
  return item;
}

const mappingProductCombination = (prod, prodCombi) => {
  prod.combination = prodCombi;
  prod.reference = prodCombi.reference || '';
  prod.images = prodCombi.images;
  prod.variant = getAttibutes(prodCombi.attributes);
  prod.product_combination_id = prodCombi._id;
  prod.ref_name = '[' + prod.reference + '] ' + prod.name;
  prod.product_name = '[' + prod.reference + '] ' + prod.name;
  if (prod.images?.[0]?.url) {
    prod.image = prod.images?.[0]?.url;
  }

  return prod;
};

const convertProductPerCombinations = (data) => {
  const products = [];
  for (let i = 0; i < data.length; i++) {
    const prod = data[i];
    if (prod?.combinations?.length) {
      for (let j = 0; j < prod.combinations.length; j++) {
        const prodCombi = prod.combinations[j];
        const combi = JSON.parse(JSON.stringify(prod));
        prodCombi.id = prodCombi._id;
        combi.combination = prodCombi;
        combi.reference = prodCombi.reference || '';
        combi.images = prodCombi.images;
        combi.variant = getAttibutes(prodCombi.attributes);
        combi.product_combination_id = prodCombi._id;
        combi.ref_name = '[' + combi.reference + '] ' + combi.name;
        if (
          !!prodCombi?.id &&
          (isVn() ? prodCombi.is_active_in_b2b_vn : prodCombi.is_active_in_b2b)
        ) {
          products.push(combi);
        }
      }
      if (prod.combinations) {
        delete prod.combinations;
      }
    } else {
      products.push(prod);
    }
  }
  return products;
};

const findMatchValue = (a, b) => {
  let result = '';
  b.split(' ').forEach(function (str, i) {
    if (str.toLowerCase().indexOf(a.toLowerCase()) > -1) {
      result += str;
    }
  });
  return result;
};

function checkDetailAddress(lists = [], value = '') {
  return lists.find((x) => {
    const keyword = value?.name ? value.name : value ? value : '';
    return (
      findMatchValue(x.name, keyword) ||
      x.name.toLowerCase() === (keyword ? keyword.toLowerCase() : '')
    );
  });
}

function hasProductBadge(data) {
  return Boolean(data.is_best_seller || data.is_promo || data.is_new);
}

function convertPromotion(data) {
  const result = [];

  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (item.promo_rule) {
      item.promo_rule.periode =
        item.promo_rule.from_date || item.promo_rule.to_date
          ? `${
              item.promo_rule.from_date
                ? parseDate(
                    item.promo_rule.from_date,
                    isWeb ? 'd MMMM yyyy' : 'd MMM yyyy',
                  )
                : '-'
            } - ${
              item.promo_rule.to_date
                ? parseDate(
                    item.promo_rule.to_date,
                    isWeb ? 'd MMMM yyyy' : 'd MMM yyyy',
                  )
                : '-'
            }`
          : '-';
    } else {
      item.periode =
        item.from_date || item.to_date
          ? `${
              item.from_date
                ? parseDate(
                    item.from_date,
                    isWeb ? 'd MMMM yyyy' : 'd MMM yyyy',
                  )
                : '-'
            } - ${
              item.to_date
                ? parseDate(item.to_date, isWeb ? 'd MMMM yyyy' : 'd MMM yyyy')
                : '-'
            }`
          : '-';
      item.promo_rule = item;
    }
    result.push(item);
  }

  return result;
}

function convertMonthNumber(month) {
  return month && month.toString().length == 1 ? `0${month}` : month;
}

function convertPeriodFilter(months = MONTH_NAME) {
  const filter_periods = [];
  for (let i = 2019; i < 2030; i++) {
    for (let j = 0; j < 12; j++) {
      const startDate = new Date(i, j, 1, 0, 0, 0, 0);
      const endDate = new Date(i, j + 1, 0, 23, 59, 59, 999);

      filter_periods.push({
        label: `${months[j]} ${i}`,
        value: `${convertMonthNumber(j + 1)}-${i}`,
        month: convertMonthNumber(j + 1),
        year: i,
        filter: {
          $gte: formatISO(changeTimeZone(startDate)),
          $lte: changeTimeZone(endDate),
        },
      });
    }
  }

  return filter_periods;
}

function convertYears() {
  const years = [];
  for (let i = 2019; i < 2030; i++) {
    years.push({
      label: i,
      value: i,
    });
  }

  return years;
}

function getTodayMonth() {
  const today = new Date();
  return FILTER_PERIOD.find(
    (a) =>
      a.month == convertMonthNumber(today.getMonth() + 1) &&
      a.year == today.getFullYear(),
  );
}

function getErrorMessage(error) {
  let msg = 'Something Wrong, please try again.';
  if (error?.response?.data?.message) {
    msg = error.response.data.message;
  }
  return msg;
}

function hasAccessEditTargetSetting(type, targetType) {
  let result = false;

  if (type == 'doors') {
    if (targetType == 'salesman') {
      result = !hasNoAccess(['superadmin', 'branch_head', 'general']);
    } else if (targetType == 'national') {
      result = !hasNoAccess([
        'superadmin',
        'distributor_manager',
        'general',
        'regional_distributor_manager',
      ]);
    } else if (targetType == 'branch') {
      result = !hasNoAccess(['superadmin', 'general']);
    }
  } else if (type == 'product-focus') {
    if (targetType == 'salesman') {
      result = !hasNoAccess(['superadmin', 'sales_admin', 'general']);
    }
  } else if (type == 'sales-value') {
    if (targetType == 'salesman') {
      result = !hasNoAccess(['superadmin', 'branch_head', 'general']);
    } else if (['branch', 'channel', 'national'].includes(targetType)) {
      result = !hasNoAccess(['superadmin', 'sales_admin', 'general']);
    }
  }

  return result;
}

function isKeyExists(obj, key, ...otherKey) {
  if (obj && key) {
    if (otherKey && otherKey.length > 0) {
      return isKeyExists(obj[key], ...otherKey);
    } else {
      return Object.prototype.hasOwnProperty.call(obj, key);
    }
  } else {
    return false;
  }
}

function handleTaskNotificationDetail({
  data = {},
  navigation = null,
  isTask = '',
}) {
  const targetId = data.target.id;
  const targetEntity = data.target.entity;

  if (data.verb === 'mentioned' && targetId) {
    const MENTION_ENTITY_ROUTES = {
      orders: {
        navigator: 'SalesOrderNavigator',
        screen: 'SalesOrderDetailScreen',
      },
      'return-orders': {
        navigator: 'ReturnOrderNavigator',
        screen: 'ReturnOrderDetailScreen',
      },
      'skp-internals': {
        navigator: 'SkpInternalNavigator',
        screen: 'SkpInternalDetailScreen',
      },
      'skp-externals': {
        navigator: 'SkpExternalNavigator',
        screen: 'SkpExternalDetailScreen',
      },
      'request-product-tester': {
        navigator: 'RequestProductNavigator',
        screen: 'RequestProductDetailScreen',
      },
      'request-product-eligibilities': {
        navigator: 'RequestProductNavigator',
        screen: 'RequestProductListingDetailScreen',
      },
      lpb: {
        navigator: 'LPBNavigator',
        screen: 'LPBDetailScreen',
      },
      customers: {
        navigator: 'CustomerNavigator',
        screen: 'CustomerDetailScreen',
      },
    };
    const route = MENTION_ENTITY_ROUTES[targetEntity];
    if (route) {
      navigation.navigate(route.navigator, {
        screen: route.screen,
        params: { id: targetId, openComments: 'true' },
      });
      return;
    }
  }

  if (targetEntity === 'orders' && targetId) {
    const params = {
      id: targetId,
      isTask: true,
      returnTo: {
        navigator: 'TaskNotificationNavigator',
        screen: 'TaskNotificationScreen',
        params: { task: true },
      },
    };
    if (data?.object?.orderId) {
      params.titleScreen = data.object.orderId;
    }
    navigation.navigate('SalesOrderNavigator', {
      screen: 'SalesOrderDetailScreen',
      params: params,
    });
  } else if (targetEntity === 'promotion-rules' && targetId) {
    const params = {
      id: targetId,
      name: 'Promotion Rules Approval',
      titleScreen: 'Promotion Rules Approval',
    };
    navigation.navigate('PromotionRulesNavigator', {
      screen: 'PromotionRulesDetailScreen',
      params: params,
    });
  } else if (targetEntity === 'price_rules' && targetId) {
    const params = {
      id: targetId,
      name: 'Price Rules Approval',
      titleScreen: 'Price Rules Approval',
      prev_page: 'task',
      tab: '',
    };
    navigation.navigate('PricelistNavigator', {
      screen: 'PricelistDetailScreen',
      params: params,
    });
  } else if (['customers', 'customers-clusters'].includes(targetEntity)) {
    const customerId = data?.object?.customer_id
      ? data.object.customer_id
      : targetId;
    const params = {
      id: customerId,
      name: data?.object?.name ? data.object.name : 'Customer Approval',
      titleScreen: data?.object?.name ? data.object.name : 'Customer Approval',
      prev_page: 'task',
      tab: '',
    };
    navigation.navigate('CustomerNavigator', {
      screen: 'CustomerDetailScreen',
      params: params,
    });
  } else if (targetEntity?.indexOf('target-settings') > -1 && targetId) {
    let temp_target_setting = targetEntity;
    temp_target_setting = temp_target_setting.replace('target-settings', '');
    let type = '';
    let target_type = '';
    let title = '';
    let title_section = '';
    let level = 'Level';
    const targetLevel = data?.object?.level;
    const targetSubLevel = data?.object?.sub_level;

    if (temp_target_setting?.indexOf('-mt') > -1) {
      level = 'MT';
    } else if (temp_target_setting?.indexOf('-gt') > -1) {
      level = 'GT';
    }

    if (temp_target_setting?.indexOf('sales-value') > -1) {
      type = 'sales-value';
      title = 'Sales Value';
    } else if (temp_target_setting?.indexOf('product-focus') > -1) {
      type = 'product-focus';
      title = 'Product Focus';
    } else {
      type = 'doors';
      title = 'DOORS';
    }

    let slug_level = '';
    if (['MT', 'GT'].includes(level)) {
      slug_level = `-${level.toLowerCase()}`;
    }

    if (temp_target_setting?.indexOf('national') > -1) {
      target_type = 'national';
      title_section = `National ${level}`;
      title += ` - ${title_section}`;
    } else if (temp_target_setting?.indexOf('channel') > -1) {
      target_type = `channel${slug_level}`;
      title_section = `Channel ${level}`;
      title += ` - ${title_section}`;
    } else if (temp_target_setting?.indexOf('branch') > -1) {
      target_type = `branch${slug_level}`;
      title_section = `Branch ${level}`;
      title += ` - ${title_section}`;
    } else if (temp_target_setting?.indexOf('salesman') > -1) {
      target_type = `salesman${slug_level}`;
      title_section = `Salesman ${level}`;
      title += ` - ${title_section}`;
    }

    const params = {
      type: type,
      targetType: target_type,
      targetId: data.object?.sales_team?.id || '',
      targetName: data.object?.sales_team?.name || '',
      targetYear: data?.object?.year,
      title: title,
      titleSection: data.object?.sales_team?.name
        ? `${data.object?.sales_team?.name} | ${data?.object?.year}`
        : title_section,
      targetLevel,
      targetSubLevel,
    };

    navigation.navigate('TargetSettingNavigator', {
      screen: 'TargetSettingApprovalScreen',
      params: params,
    });
  } else if (targetEntity === 'budget-pockets' && targetId) {
    const params = {
      id: targetId,
      name: 'Budget Pocket Approval',
      titleScreen: 'Budget Pocket Approval',
    };
    navigation.navigate('BudgetPocketNavigator', {
      screen: 'BudgetPocketDetailScreen',
      params: params,
    });
  } else if (targetEntity === 'return-orders' && targetId) {
    const params = {
      id: targetId,
      name: 'Return Order Approval',
      titleScreen: 'Return Order Approval',
    };
    navigation.navigate('ReturnOrderNavigator', {
      screen: 'ReturnOrderDetailScreen',
      params: params,
    });
  } else if (targetEntity === 'skp-internals' && targetId) {
    const params = {
      id: targetId,
      name: 'SKP Internal Approval',
      titleScreen: 'SKP Internal Approval',
    };
    navigation.navigate('SkpInternalNavigator', {
      screen: 'SkpInternalDetailScreen',
      params: params,
    });
  } else if (targetEntity === 'skp-externals' && targetId) {
    const params = {
      id: targetId,
      name: 'SKP External Approval',
      titleScreen: 'SKP External Approval',
    };
    navigation.navigate('SkpExternalNavigator', {
      screen: 'SkpExternalDetailScreen',
      params: params,
    });
  } else if (targetEntity === 'lpb' && targetId) {
    const params = {
      id: targetId,
      name: 'GRN Approval',
      titleScreen: 'GRN Approval',
    };
    navigation.navigate('LPBNavigator', {
      screen: 'LPBDetailScreen',
      params: params,
    });
  } else if (targetEntity === 'request-product-tester' && targetId) {
    const params = {
      id: targetId,
      name: 'Request Product Tester Approval',
      titleScreen: 'Request Product Tester Approval',
    };
    navigation.navigate('RequestProductNavigator', {
      screen: 'RequestProductDetailScreen',
      params: params,
    });
  } else {
    navigation.navigate('TaskNotificationNavigator', {
      screen: 'TaskNotificationDetailScreen',
      params: {
        titleScreen: data.title ? data.title : '',
        name: data.title ? data.title : '',
        id: data._id,
        isTask,
      },
    });
  }
}

function prettyNumber(item) {
  if (!item) {
    return 0;
  }
  if (item >= 1000000000000) {
    item = (item / 1000000000000).toFixed(1).replace(/\.0$/, '') + 'T';
    item = item.replace('.', ',');
  } else if (item >= 1000000000) {
    item = (item / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
    item = item.replace('.', ',');
  } else if (item >= 1000000) {
    item = (item / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    item = item.replace('.', ',');
  } else if (item >= 1000) {
    item = (item / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    item = item.replace('.', ',');
  }
  return item;
}

function convertTargetSettingValue(value, type = 'amount', pretty = true) {
  let result = value || 0;
  if (pretty) {
    result = prettyNumber(result);
  }
  if (type == 'amount') {
    result = currency(result, true);
  } else if (type == 'doors') {
    result = `${result} DOORS`;
  }
  return result;
}

function targetCalculation(actual = 0, target = 0) {
  const total_actual = actual && !isNaN(Number(actual)) ? Number(actual) : 0;
  const total_target = target && !isNaN(Number(target)) ? Number(target) : 0;
  const result = (total_actual / total_target) * 100;
  return !isNaN(result) ? Math.ceil(result) : 0;
}

function hasDashboardAccess(accessKey = '') {
  const accessCheck = (indexes = []) => {
    const result = ['superadmin', 'general'];

    const roles = [
      'vice_president',
      'general_manager',
      'distributor_manager',
      'vice_president_finance',
      'finance_head',
      'tax_support',
      'budget_controller',
      'billing_supervisor',
      'general_manager_marketing',
      'marketing_admin',
      'marketing_support',
      'regional_manager',
      'regional_support',
      'key_account_manager',
      'group_key_account_manager',
      'national_key_account_manager',
      'branch_head',
      'finance_supervisor',
      'sales_supervisor',
      'sales_admin',
      'salesman',
      'regional_distributor_manager',
    ];

    for (let i = 0; i < indexes.length; i++) {
      const key = indexes[i];
      result.push(roles[key]);
    }

    return result?.length ? !hasNoAccess(result) : false;
  };

  const accesses = {
    'sales-value-national': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 15]),
    'sales-value-cluster': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
    'sales-value-regional': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
    'sales-value-channel': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15]),
    'sales-value-brand': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]),
    'sales-value-branch': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]),
    'sales-value-salesteam': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]),
    'sales-value-salesman': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]),

    'product-focus-national': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
    'product-focus-regional': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
    'product-focus-channel': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
    ]),
    'product-focus-branch': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
    ]),
    'product-focus-salesman': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]),

    'doors-national': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
    'doors-regional': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
    'doors-channel': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
    'doors-branch': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
    ]),
    'doors-salesman': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]),

    'ar-national': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
    'ar-regional': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
    'ar-channel': accessCheck([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    'ar-branch': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
    ]),
    'ar-salesman': accessCheck([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]),
  };
  return Boolean(accesses[accessKey]);
}

function convertDecimal(value, dp) {
  if (!value) {
    return value;
  }
  return +parseFloat(value).toFixed(dp);
}

function isQuotationAmountDiff(amount1, amount2, useThreshold = false) {
  const amountDiff = Math.abs(Number(amount1 || 0) - Number(amount2 || 0));
  const amountThreshold = useThreshold ? QUOTATION_AMOUNT_THRESHOLD : 0;
  if (amountDiff > amountThreshold) {
    return true;
  }
  return false;
}

async function saveDataToStorage(key, value) {
  const stringValue = JSON.stringify(value);
  if (isWebPlatform) {
    Cookies.set(key, stringValue, {
      domain: COOKIES_DOMAIN,
      expires: COOKIES_EXPIRY,
    });
  } else {
    await AsyncStorage.setItem(key, stringValue);
  }
}

async function clearStorageData(key) {
  if (isWebPlatform) {
    Cookies.remove(key, {
      domain: COOKIES_DOMAIN,
    });
  } else {
    await AsyncStorage.removeItem(key);
  }
}

async function getDataFromStorage(key) {
  let value = null;
  if (isWebPlatform) {
    value = Cookies.get(key, {
      domain: COOKIES_DOMAIN,
    });
  } else {
    value = await AsyncStorage.getItem(key);
  }
  return value ? JSON.parse(value) : null;
}

function getActivityTodoStorageKey(activityId) {
  if (!activityId) {
    return '';
  }
  return `B2B-ACTIVITY-TODO-OFFLINE-${activityId}`;
}

async function getActivityTodoStorage(activityId) {
  const key = getActivityTodoStorageKey(activityId);
  if (!key) {
    return null;
  }
  return await getDataFromStorage(key);
}

async function setActivityTodoStorage(activityId, data) {
  const key = getActivityTodoStorageKey(activityId);
  if (!key) {
    return null;
  }
  return await saveDataToStorage(key, {
    ...(data || {}),
    __meta: {
      ...(data?.__meta || {}),
      updatedAt: new Date().toISOString(),
    },
  });
}

async function clearActivityTodoStorage(activityId) {
  const key = getActivityTodoStorageKey(activityId);
  if (!key) {
    return null;
  }
  return await clearStorageData(key);
}

async function clearVisibilityCacheByActivity(activityId) {
  if (isWebPlatform || !activityId) {
    return;
  }
  const prefixes = [
    `B2B-VISIBILITY-CACHE-${activityId}`,
    `B2B-VISIBILITY-PRODUCT-META-${activityId}-`,
  ];
  try {
    const keys = await AsyncStorage.getAllKeys();
    const visibilityKeys = keys.filter((key) =>
      prefixes.some((prefix) => key.startsWith(prefix)),
    );
    if (!visibilityKeys.length) {
      return;
    }
    await AsyncStorage.multiRemove(visibilityKeys);
  } catch (error) {}
}

async function cleanExpiredActivityTodoStorage(maxAgeDays = 2) {
  if (isWebPlatform) {
    return;
  }

  const prefixes = [
    'B2B-ACTIVITY-TODO-OFFLINE-',
    'B2B-VISIBILITY-CACHE-',
    'B2B-VISIBILITY-PRODUCT-META-',
  ];
  const maxAgeMs = maxAgeDays * 24 * 60 * 60 * 1000;
  const now = Date.now();

  try {
    const keys = await AsyncStorage.getAllKeys();
    const todoKeys = keys.filter((key) =>
      prefixes.some((prefix) => key.startsWith(prefix)),
    );
    if (!todoKeys.length) {
      return;
    }

    const entries = await AsyncStorage.multiGet(todoKeys);
    for (let i = 0; i < entries.length; i++) {
      const [key, value] = entries[i];
      if (!value) {
        continue;
      }

      try {
        const parsed = JSON.parse(value);
        let updatedAt = parsed?.__meta?.updatedAt || parsed?.updatedAt;

        if (!updatedAt) {
          const itemUpdated = Object.values(parsed?.items || {})
            .map((item) => item?.updatedAt)
            .filter(Boolean)
            .sort()
            .pop();
          updatedAt = itemUpdated || null;
        }

        if (!updatedAt) {
          await AsyncStorage.removeItem(key);
          continue;
        }

        const updatedAtMs = new Date(updatedAt).getTime();
        if (!updatedAtMs || now - updatedAtMs >= maxAgeMs) {
          await AsyncStorage.removeItem(key);
        }
      } catch (error) {
        await AsyncStorage.removeItem(key);
      }
    }
  } catch (error) {}
}

function truncateString(str, maxLength = 20) {
  if (str.length > maxLength) {
    return str.slice(0, maxLength - 3) + '...';
  }
  return str;
}

function normalizeKeyword(keyword) {
  if (!keyword) {
    return '';
  }
  keyword = latinize(keyword);
  keyword = keyword.replace(/[^a-zA-Z0-9 ]/g, '');
  keyword = keyword.trim();
  keyword = keyword.toLowerCase();
  return keyword;
}

function isVn() {
  if (isNative) {
    const storedCountry = SyncStorage.get('soc_cn');
    return storedCountry === 'VN';
  }

  const hostname = window.location.hostname;

  // Return based on cookie 'soc_cn' when running locally
  if (hostname === 'localhost') {
    return Cookies.get('soc_cn') === 'VN';
  }

  if (!Config.B2B_WEB_VN_URL) {
    return false;
  }

  // Otherwise, check if the hostname matches the Vietnam domain
  return hostname.includes(new URL(Config.B2B_WEB_VN_URL).hostname);
}

function getCurrency() {
  if (isVn()) {
    return '₫';
  }
  return 'Rp';
}

function getTaxList(vat, taxType = null) {
  const vatValue = vat || 0;
  const taxes = [
    {
      id: `inc-${vatValue}`,
      name: `Sales tax inc. ${vatValue}%`,
      type: 'inc',
      percentage: `${vatValue}`,
    },
    {
      id: `exc-${vatValue}`,
      name: `Sales tax exc. ${vatValue}%`,
      type: 'exc',
      percentage: `${vatValue}`,
    },
  ];
  return taxType ? taxes.filter((t) => t.type == taxType) : taxes;
}

const formatTimeWithAMPM = (timeString) => {
  if (!timeString) {
    return '';
  }

  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';

  return `${hours}:${minutes} ${ampm}`;
};

const defaultCountry = () => (isVn() ? 'vietnam' : 'indonesia');

const isValidObjectId = (val) => {
  if (!val) {
    return false;
  }
  if (val === undefined || val === null || val === '') {
    return false;
  }
  return /^[0-9a-fA-F]{24}$/.test(val);
};

const formatCoaTaxLabel = (tax) => {
  if (!tax) {
    return '-';
  }
  return `${tax.tax_value || 0}% - ${tax.description || ''} ${
    tax.is_default ? '(Default)' : ''
  }`.trim();
};

// Get taxes data from skp internal and coa tax
const getSkpInternalTaxes = (coa, skpInternal) => {
  let taxCorporate = (coa.tax_corporate || []).find(
    (t) => t._id.toString() == skpInternal?.coa_tax?.tax_corporate?.id,
  );
  if (!taxCorporate) {
    taxCorporate = (coa.tax_corporate || []).find((t) => t.is_default);
  }

  let taxPersonal = (coa.tax_personal || []).find(
    (t) => t._id.toString() == skpInternal?.coa_tax?.tax_personal?.id,
  );
  if (!taxPersonal) {
    taxPersonal = (coa.tax_personal || []).find((t) => t.is_default);
  }

  let nonTaxCorporate = (coa.non_tax_corporate || []).find(
    (t) => t._id.toString() == skpInternal?.coa_tax?.non_tax_corporate?.id,
  );
  if (!nonTaxCorporate) {
    nonTaxCorporate = (coa.non_tax_corporate || []).find((t) => t.is_default);
  }

  let nonTaxPersonal = (coa.non_tax_personal || []).find(
    (t) => t._id.toString() == skpInternal?.coa_tax?.non_tax_personal?.id,
  );
  if (!nonTaxPersonal) {
    nonTaxPersonal = (coa.non_tax_personal || []).find((t) => t.is_default);
  }

  if (taxCorporate) {
    taxCorporate['id'] = taxCorporate.id || taxCorporate._id;
  }
  if (taxPersonal) {
    taxPersonal['id'] = taxPersonal.id || taxPersonal._id;
  }
  if (nonTaxCorporate) {
    nonTaxCorporate['id'] = nonTaxCorporate.id || nonTaxCorporate._id;
  }
  if (nonTaxPersonal) {
    nonTaxPersonal['id'] = nonTaxPersonal.id || nonTaxPersonal._id;
  }

  return {
    taxCorporate,
    taxPersonal,
    nonTaxCorporate,
    nonTaxPersonal,
  };
};

// Format coa tax to support new data structure
const formatCoaTaxMultipleTax = (coa, skpInternal) => {
  const { taxCorporate, taxPersonal, nonTaxCorporate, nonTaxPersonal } =
    getSkpInternalTaxes(coa, skpInternal);

  if (taxCorporate) {
    coa.pph_npwp_badan = taxCorporate.tax_value;
  }
  if (taxPersonal) {
    coa.pph_npwp_pribadi = taxPersonal.tax_value;
  }
  if (nonTaxCorporate) {
    coa.pph_non_npwp_badan = nonTaxCorporate.tax_value;
  }
  if (nonTaxPersonal) {
    coa.pph_non_npwp_pribadi = nonTaxPersonal.tax_value;
  }

  return coa;
};

const formatSkpType = (skpType) => {
  const SKP_MAP = {
    subdistributor: 'Subdistributor',
    mt: 'MT',
    gt: 'GT',
  };
  return SKP_MAP[skpType?.toLowerCase()] || '-';
};

const isSkpType = (skp_internal, skpType) => {
  if (!skp_internal) {
    return false;
  }
  let isTypeTrue = skp_internal?.skp_type?.toLowerCase() == skpType;
  if (skp_internal?.coa_tax?.skp_type_flow) {
    isTypeTrue = skp_internal?.coa_tax?.skp_type_flow == skpType;
  }

  return isTypeTrue;
};

const escapeRegexChars = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

function generateUUIDv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getByPath(obj, path) {
  if (obj == null) {
    return undefined;
  }
  const segments = Array.isArray(path)
    ? path
    : String(path)
        .replace(/\[(\w+)\]/g, '.$1')
        .replace(/^\./, '')
        .split('.');

  let cur = obj;
  for (const seg of segments) {
    if (cur == null) {
      return undefined;
    }
    cur = cur[seg];
  }
  return cur;
}

function removeDuplicate(arr, path) {
  const seen = new Set();
  const out = [];
  for (const obj of arr) {
    const k = getByPath(obj, path);
    if (!seen.has(k)) {
      seen.add(k);
      out.push(obj);
    }
  }
  return out;
}

const getWebUrl = () => {
  if (isVn()) {
    return Config.B2B_WEB_VN_URL;
  } else {
    return Config.B2B_WEB_URL;
  }
};

const exportPdf = async (pdfType, id = null, navigation = null) => {
  const jwtToken = await getDataFromStorage('B2B-SOCIOLLA-TOKEN');
  const queryObject = {
    type: pdfType,
    t: jwtToken,
  };
  if (id) {
    queryObject.id = id;
  }

  if (isWeb && navigation) {
    navigation.navigate('PdfNavigator', {
      screen: 'PdfScreen',
      params: queryObject,
    });
    return;
  }

  const b2bUrl = getWebUrl();
  const qs = new URLSearchParams(queryObject).toString();
  const pdfUrl = `${b2bUrl}/pdf-viewer?${qs}`;
  const supported = await Linking.canOpenURL(pdfUrl);
  if (supported) {
    await Linking.openURL(pdfUrl);
  } else {
    console.log('invalid pdf url: ', pdfUrl);
  }
};

function pdfSafeValue(val) {
  if (val === null || val === undefined || val === '') {
    return '-';
  }
  if (typeof val === 'string' && val.trim() === '') {
    return '-';
  }
  return val;
}

function formatTargetSettingTitle({
  titlePage = '',
  paramType = '',
  paramTargetType = '',
  titleSection = '',
}) {
  let formattedTitle = titlePage || '';
  const isSalesValue = Boolean(paramType === 'sales-value');
  const isDoors = Boolean(paramType === 'doors');
  const isProductFocus = Boolean(paramType === 'product-focus');
  const isSalesValueBranch =
    isSalesValue && ['branch-gt', 'branch-mt'].includes(paramTargetType);
  const isSalesValueSalesman = isSalesValue && paramTargetType === 'salesman';

  if (isSalesValue) {
    if (isSalesValueBranch) {
      if (paramTargetType === 'branch-gt') {
        formattedTitle = 'Sales Value - Branch Level - GT';
      } else if (paramTargetType === 'branch-mt') {
        formattedTitle = 'Sales Value - Branch Level - MT';
      }
    } else if (isSalesValueSalesman) {
      if (titleSection) {
        formattedTitle = `Sales Value - Sales Team & Salesman Level - ${
          titleSection.split(' | ')[0]
        }`;
      } else {
        formattedTitle = 'Sales Value - Sales Team & Salesman Level';
      }
    }
  } else if (isProductFocus) {
    if (paramTargetType === 'salesman-gt') {
      formattedTitle = 'Product Focus - Salesman Type Level - GT';
    } else if (paramTargetType === 'salesman-mt') {
      formattedTitle = 'Product Focus - Salesman Type Level - MT';
    } else {
      formattedTitle = 'Product Focus - Salesman Type Level';
    }
  } else if (isDoors) {
    formattedTitle = formattedTitle.replace('DOOR -', 'DOORS -');
  }

  return formattedTitle;
}

function getTimezone() {
  return dayjs.tz.guess() || 'Asia/Jakarta';
}

function getOffset() {
  return dayjs().format('Z'); // Format: +07:00 or -05:00
}

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const SO_EXPIRY_REMINDER_DAYS = 7;
const SKP_JOINED_REMINDER_DAYS = 14;

// Draft sales order reminder from D-7 of expiration_date (calendar days, device timezone).
// Returns null when no reminder applies; the reminder disappears once the order leaves draft.
// Literal copy is translated here (id.json) since the day count can't be part of a dictionary key.
const getSalesOrderExpiryReminder = (order) => {
  if (order?.status != 'draft' || !order?.expiration_date) {
    return null;
  }
  const daysLeft = dayjs(order.expiration_date)
    .startOf('day')
    .diff(dayjs().startOf('day'), 'day');
  if (daysLeft > SO_EXPIRY_REMINDER_DAYS) {
    return null;
  }
  if (daysLeft < 0) {
    return 'Expired';
  }
  if (daysLeft == 0) {
    return 'Expires today';
  }
  if (daysLeft == 1) {
    return 'Expires tomorrow';
  }
  return `${translate('Expires in')} ${daysLeft} ${translate('days')}`;
};

// Joined SKP External reminder once 14 days passed since it last moved to joined (latest joined
// state_histories entry). Returns days since joined, or null when no reminder applies
// (proceeding moves it to need_approval).
const getSkpJoinedReminderDays = (skp) => {
  if (skp?.status != 'joined') {
    return null;
  }
  const joinedAt = [...(skp.state_histories || [])]
    .reverse()
    .find((history) => history.to_status == 'joined')?.changed_at;
  if (!joinedAt) {
    return null;
  }
  const daysSinceJoined = dayjs()
    .startOf('day')
    .diff(dayjs(joinedAt).startOf('day'), 'day');
  return daysSinceJoined >= SKP_JOINED_REMINDER_DAYS ? daysSinceJoined : null;
};

export {
  hasNoAccess,
  getEnvironment,
  getGoogleMapKey,
  getMapWebViewBaseUrl,
  isDisableSubmit,
  handleTaskCode,
  parseDate,
  timeAgo,
  getRandomColor,
  getCenterValue,
  firstLetter,
  deSlug,
  setTitleHeader,
  getHeaderTitleStyle,
  setDefaultStackOption,
  generateMimeType,
  getFileNameFromUrl,
  uploadS3,
  chooseImagePicker,
  takePicture,
  savePhotoToGallery,
  getAutoSavePhoto,
  setAutoSavePhoto,
  hasGalleryPermission,
  downloadFromUrlAndroid,
  downloadFile,
  exportCSVFile,
  convertFullAddress,
  currency,
  generateStatus,
  generateConstant,
  getStatus,
  getAttibutes,
  getProductCombination,
  splitProductByCombination,
  capitalizeText,
  getConstant,
  calculateLocationDistance,
  numberOnly,
  numberWithDecimal,
  stripLineBreaks,
  getLongLat,
  generateGMapsLink,
  getUniqeItem,
  promotionRulesParameters,
  exportCsvApi,
  convertUnderscoreString,
  calculateSalesOrderProduct,
  setSavedFilter,
  getSavedFilter,
  convertMarketTypeData,
  csvToArray,
  convertTimeOfDate,
  randomString,
  convertProductMarketType,
  mappingProductCombination,
  convertProductPerCombinations,
  changeTimeZone,
  hasProductBadge,
  checkDetailAddress,
  findMatchValue,
  convertPromotion,
  imageCdn,
  imageSource,
  convertMonthNumber,
  convertPeriodFilter,
  convertYears,
  getTodayMonth,
  getErrorMessage,
  hasAccessEditTargetSetting,
  isKeyExists,
  // uploadBackground,
  handleTaskNotificationDetail,
  prettyNumber,
  convertTargetSettingValue,
  targetCalculation,
  hasDashboardAccess,
  convertDecimal,
  getImageRatio,
  chooseMultipleImagePicker,
  isQuotationAmountDiff,
  saveDataToStorage,
  clearStorageData,
  getDataFromStorage,
  getActivityTodoStorageKey,
  getActivityTodoStorage,
  setActivityTodoStorage,
  clearActivityTodoStorage,
  clearVisibilityCacheByActivity,
  cleanExpiredActivityTodoStorage,
  truncateString,
  normalizeKeyword,
  isVn,
  getCurrency,
  getTaxList,
  formatTimeWithAMPM,
  defaultCountry,
  isValidObjectId,
  formatCoaTaxLabel,
  formatCoaTaxMultipleTax,
  getSkpInternalTaxes,
  formatSkpType,
  downloadCsvTemplate,
  isSkpType,
  escapeRegexChars,
  generateUUIDv4,
  removeDuplicate,
  exportPdf,
  pdfSafeValue,
  downloadDirectFile,
  formatTargetSettingTitle,
  getTimezone,
  getOffset,
  sleep,
  getSalesOrderExpiryReminder,
  getSkpJoinedReminderDays,
};
